import { useTranslation } from 'react-i18next';
import type { EmailLogStatus } from '@/api/emailLog/emailLogApi.types';
import { Badge } from '@/components/ui/badge';

interface EmailLogStatusBadgeProps {
  status: EmailLogStatus;
}

export function EmailLogStatusBadge({ status }: EmailLogStatusBadgeProps) {
  const { t } = useTranslation('emailLog');
  return (
    <Badge tone={status === 'sent' ? 'success' : 'danger'} shape="tag" size="sm">
      {t('status.' + status)}
    </Badge>
  );
}
